import Vue from "vue";
import 'aos/dist/aos.css'
import router from "./routes/core/engine";
import {Plugin} from 'vue-fragment';
import VueMeta from 'vue-meta';
import {navigationComponents} from "./core/navigation-components";
import {permissionsMixin} from "./core/data/global";
import vClickOutside from 'v-click-outside';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import 'vue-select/dist/vue-select.css';


Vue.use(vClickOutside)
Vue.use(VueMeta);
Vue.use(Plugin);
Vue.mixin(permissionsMixin);

Vue.use(Toast, {
    position: "top-right",
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    toastClassName: "project-font",
    icon: true
});

require('./boot/axios');
require('./boot/alerts');
require('./boot/filters');
require('./boot/helpers');

const callToServiceInterval = 5000;

window.vue = new Vue({
    router: router,
    mixins: [navigationComponents],
    components: {
        CorporateLogin: () => import("./components/corporate/Login"),
        CorporateRegister: () => import("./components/corporate/Register"),
        CorporateBiller: () => import("./components/corporate/billers/onboarding/Biller.vue"),
        CorporateEvent: () => import("./components/corporate/setup/Event"),
        CorporateReset: () => import("./components/corporate/Reset"),
        Login: () => import("./components/auth/Login"),
        Reset: () => import("./components/auth/Reset"),
        Sim: () => import("./components/auth/Simulator"),
        Can: () => import("./components/core/can"),
        Dropdown: () => import("./components/core/dropdown"),
        AppHeader: () => import("./components/core/AppHeader"),
    },
    el: '#app',
    data: () => ({
        service: 'ZESA',
        serviceIndex: 0,
        dropdowns: {
            payBills: false,
        }
    }),
    methods: {
        logout: function () {
            document.getElementById('logout-form').submit();
        },
        toggleDropdown(menu, state) {
            this.dropdowns[menu] = state;
        },
        rotateServices() {
            const index = this.serviceIndex + 1;
            this.serviceIndex = index >= this.menu.length ? 0 : index;

            this.service = this.menu[this.serviceIndex].name || this.menu[this.serviceIndex].title;

            setTimeout(() => this.rotateServices(), callToServiceInterval);
        }
    },
    mounted() {
        setTimeout(() => this.rotateServices(), callToServiceInterval);
    },
});
